import React from 'react'

const Compliance = () => {
  return (
    <div>Compliance</div>
  )
}

export default Compliance